import type * as Types from '../../../schemas/shopify/admin.types';

export type PickPageArticleNodeFragment = Pick<
  Types.Article,
  'id' | 'handle' | 'title' | 'isPublished' | 'templateSuffix'
> & { blog: Pick<Types.Blog, 'handle'>; image?: Types.Maybe<Pick<Types.Image, 'url'>> };

export const PickPageArticleNodeFragmentDoc = `
    fragment PickPageArticleNode on Article {
  id
  handle
  title
  isPublished
  templateSuffix
  blog {
    handle
  }
  image {
    url
  }
}
    `;
